export default __webpack_public_path__ + "static/Scroll-Image---Other-Concrete-Asphalt-Removal-e0c508a5303197170333d00fc4502679.jpg";